const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export default class ShowcaseContextInstance {
  private static instance: any;

  public static async get(): Promise<any> {
    if (ShowcaseContextInstance.instance == null) {
      while (ShowcaseContextInstance.instance == null) {
        await delay(250);
      }
      return ShowcaseContextInstance.instance;
    }
    return this.instance;
  }

  public static set(instance: any) {
    if (!instance) {
      throw new Error('Failed to setup ThreeJS');
    }
    this.instance = instance;
  }

  public static async setFromRuntime(instance: any) {
    if (instance.get() != null) {
      ShowcaseContextInstance.set(instance.get());
    } else {
      while (instance.get() == null) {
        await delay(250);
      }
      ShowcaseContextInstance.set(instance.get());
    }
  }
}
